import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';
import { VinDataRow } from 'site-modules/shared/components/vin-decoder/vin-data-row/vin-data-row';

import './vin-info-section.scss';

const PREVIEW_ROWS_NUMBER = 5;

export function VinInfoSection({ title, data = null, isFirstSection = false, keyword = null }) {
  if (!data || data.length === 0) {
    return null;
  }

  const previewData = isFirstSection ? data : data.slice(0, PREVIEW_ROWS_NUMBER);
  const otherData = isFirstSection ? null : data.slice(PREVIEW_ROWS_NUMBER);

  return (
    <section
      className="features-section bg-cool-gray-90 rounded-12 px-1 px-md-1_5 py-1_5 mb-1 mb-md-1_5"
      data-tracking-parent={`vin_info_${title.toLowerCase().replaceAll(' ', '_')}`}
      aria-labelledby={`vin-section-${title.toLowerCase().replaceAll(' ', '-')}`}
    >
      <div className="mb-1">
        <h2 className="heading-4 d-inline-block mb-0" id={`vin-section-${title.toLowerCase().replaceAll(' ', '-')}`}>
          {title}
        </h2>
      </div>

      <div className="bg-white rounded-8 px-0_75 px-md-1 py-0_5">
        <table
          className={classnames('table mb-0', { 'with-other': !!otherData?.length })}
          aria-label={`${title} information table`}
        >
          <colgroup className="vehicle-columns">
            <col className="feature" />
            <col className="value" />
          </colgroup>
          <tbody>
            {previewData.map(feature => {
              return <VinDataRow key={feature.name} feature={feature} keyword={keyword} />;
            })}
          </tbody>
        </table>
        {!!otherData?.length && (
          <ContentCollapse
            btnContainerClasses="py-0_75 px-0_5"
            btnClasses="p-0 text-blue-40 text-underline fw-normal"
            textClosed="Show more"
            textOpen="Show less"
            ariaLabelHeading={`about ${title}`}
          >
            <table className="table mb-0" aria-label={`Additional ${title} information`}>
              <colgroup className="vehicle-columns">
                <col className="feature" />
                <col className="value" />
              </colgroup>
              <tbody>
                {otherData.map(feature => (
                  <VinDataRow key={feature.name} feature={feature} keyword={keyword} />
                ))}
              </tbody>
            </table>
          </ContentCollapse>
        )}
      </div>
    </section>
  );
}

VinInfoSection.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  isFirstSection: PropTypes.bool,
  keyword: PropTypes.string,
};
